// One-way taxi pricing data with dynamic calculation
// Formula: one_way_fare = (distance_km × per_km_rate) + toll

import { calculateOneWayFare } from '../utils/pricingCalculator';

// Vehicle rates per kilometer (updated 2026 rates)
const vehicleRatesPerKm = {
  marutiDzire: 50,
  brezza: 50,
  marutiErtiga: 60,
  kiaCarens: 60,
  innovaCrysta: 70,
  innovaCrysta7Plus1: 75,
  innovaHycross: 70,
  tempoTraveller12: 72,
  tempoTraveller17: 77,
  tempoTraveller25: 98,
  urbania12: 70,
  urbania16: 85
};

// Special fixed pricing for specific routes
const specialRoutePricing = {
  'anandpur-sahib-faridabad': {
    marutiDzire: 5500,
    brezza: 6600,
    marutiErtiga: 7200,
    kiaCarens: 8300,
    innovaCrysta: 9400,
    innovaCrysta7Plus1: 9900,
    innovaHycross: 11600
  },
  'faridabad-anandpur-sahib': {
    marutiDzire: 5500,
    brezza: 6600,
    marutiErtiga: 7200,
    kiaCarens: 8300,
    innovaCrysta: 9400,
    innovaCrysta7Plus1: 9900,
    innovaHycross: 11600
  }
};

// Distance and toll data for city pairs (in km and INR)
const cityDistanceData = {
  'delhi-ludhiana': { distance: 70, toll: 500 },
  'ludhiana-delhi': { distance: 70, toll: 500 },
  'anandpur-sahib-faridabad': { distance: 280, toll: 400 },
  'faridabad-anandpur-sahib': { distance: 280, toll: 400 },
  'chandigarh-delhi': { distance: 250, toll: 350 },
  'delhi-chandigarh': { distance: 250, toll: 350 },
  'amritsar-delhi': { distance: 450, toll: 650 },
  'delhi-amritsar': { distance: 450, toll: 650 },
  'ludhiana-chandigarh': { distance: 100, toll: 150 },
  'chandigarh-ludhiana': { distance: 100, toll: 150 },
  'mohali-delhi': { distance: 245, toll: 350 },
  'delhi-mohali': { distance: 245, toll: 350 },
  'patiala-delhi': { distance: 260, toll: 380 },
  'delhi-patiala': { distance: 260, toll: 380 },
  'jalandhar-delhi': { distance: 370, toll: 550 },
  'delhi-jalandhar': { distance: 370, toll: 550 },
  'bathinda-delhi': { distance: 310, toll: 450 },
  'delhi-bathinda': { distance: 310, toll: 450 },
  'amritsar-chandigarh': { distance: 230, toll: 320 },
  'chandigarh-amritsar': { distance: 230, toll: 320 },
  'ludhiana-amritsar': { distance: 140, toll: 200 },
  'amritsar-ludhiana': { distance: 140, toll: 200 },
  'chandigarh-shimla': { distance: 115, toll: 150 },
  'shimla-chandigarh': { distance: 115, toll: 150 },
  'chandigarh-manali': { distance: 310, toll: 450 },
  'manali-chandigarh': { distance: 310, toll: 450 },
  'delhi-shimla': { distance: 350, toll: 500 },
  'shimla-delhi': { distance: 350, toll: 500 },
  'delhi-manali': { distance: 540, toll: 800 },
  'manali-delhi': { distance: 540, toll: 800 },
  'chandigarh-dharamshala': { distance: 240, toll: 350 },
  'dharamshala-chandigarh': { distance: 240, toll: 350 },
  'delhi-dharamshala': { distance: 475, toll: 700 },
  'dharamshala-delhi': { distance: 475, toll: 700 },
  'amritsar-dharamshala': { distance: 200, toll: 280 },
  'dharamshala-amritsar': { distance: 200, toll: 280 },
  'chandigarh-dalhousie': { distance: 320, toll: 450 },
  'dalhousie-chandigarh': { distance: 320, toll: 450 },
  'delhi-dalhousie': { distance: 560, toll: 820 },
  'dalhousie-delhi': { distance: 560, toll: 820 },
  'chandigarh-kasauli': { distance: 65, toll: 80 },
  'kasauli-chandigarh': { distance: 65, toll: 80 },
  'delhi-kasauli': { distance: 300, toll: 420 },
  'kasauli-delhi': { distance: 300, toll: 420 },
  'chandigarh-mussoorie': { distance: 170, toll: 240 },
  'mussoorie-chandigarh': { distance: 170, toll: 240 },
  'delhi-mussoorie': { distance: 290, toll: 400 },
  'mussoorie-delhi': { distance: 290, toll: 400 },
  'delhi-haridwar': { distance: 220, toll: 300 },
  'haridwar-delhi': { distance: 220, toll: 300 },
  'delhi-rishikesh': { distance: 240, toll: 330 },
  'rishikesh-delhi': { distance: 240, toll: 330 },
  'chandigarh-haridwar': { distance: 180, toll: 250 },
  'haridwar-chandigarh': { distance: 180, toll: 250 },
  'chandigarh-rishikesh': { distance: 200, toll: 280 },
  'rishikesh-chandigarh': { distance: 200, toll: 280 },
  'delhi-agra': { distance: 230, toll: 320 },
  'agra-delhi': { distance: 230, toll: 320 },
  'delhi-jaipur': { distance: 280, toll: 400 },
  'jaipur-delhi': { distance: 280, toll: 400 },
  'chandigarh-jaipur': { distance: 520, toll: 760 },
  'jaipur-chandigarh': { distance: 520, toll: 760 },
  'delhi-nainital': { distance: 320, toll: 450 },
  'nainital-delhi': { distance: 320, toll: 450 },
  'delhi-jim-corbett': { distance: 260, toll: 370 },
  'jim-corbett-delhi': { distance: 260, toll: 370 },
  'chandigarh-nainital': { distance: 330, toll: 470 },
  'nainital-chandigarh': { distance: 330, toll: 470 },
  'delhi-dehradun': { distance: 250, toll: 350 },
  'dehradun-delhi': { distance: 250, toll: 350 },
  'chandigarh-dehradun': { distance: 170, toll: 240 },
  'dehradun-chandigarh': { distance: 170, toll: 240 },
  'amritsar-jammu': { distance: 220, toll: 300 },
  'jammu-amritsar': { distance: 220, toll: 300 },
  'chandigarh-jammu': { distance: 420, toll: 600 },
  'jammu-chandigarh': { distance: 420, toll: 600 },
  'delhi-jammu': { distance: 590, toll: 850 },
  'jammu-delhi': { distance: 590, toll: 850 },
  'pathankot-dharamshala': { distance: 85, toll: 120 },
  'dharamshala-pathankot': { distance: 85, toll: 120 },
  'amritsar-pathankot': { distance: 115, toll: 160 },
  'pathankot-amritsar': { distance: 115, toll: 160 },
  'ludhiana-jalandhar': { distance: 80, toll: 110 },
  'jalandhar-ludhiana': { distance: 80, toll: 110 },
  'jalandhar-amritsar': { distance: 85, toll: 120 },
  'amritsar-jalandhar': { distance: 85, toll: 120 },
  'patiala-chandigarh': { distance: 65, toll: 90 },
  'chandigarh-patiala': { distance: 65, toll: 90 },
  'patiala-ludhiana': { distance: 70, toll: 100 },
  'ludhiana-patiala': { distance: 70, toll: 100 },
  'bathinda-ludhiana': { distance: 110, toll: 150 },
  'ludhiana-bathinda': { distance: 110, toll: 150 },
  'bathinda-chandigarh': { distance: 180, toll: 250 },
  'chandigarh-bathinda': { distance: 180, toll: 250 },
  'mohali-ludhiana': { distance: 95, toll: 140 },
  'ludhiana-mohali': { distance: 95, toll: 140 },
  'mohali-amritsar': { distance: 225, toll: 310 },
  'amritsar-mohali': { distance: 225, toll: 310 },
  'zirakpur-chandigarh': { distance: 10, toll: 0 },
  'chandigarh-zirakpur': { distance: 10, toll: 0 },
  'kharar-chandigarh': { distance: 15, toll: 0 },
  'chandigarh-kharar': { distance: 15, toll: 0 },
  'panchkula-chandigarh': { distance: 8, toll: 0 },
  'chandigarh-panchkula': { distance: 8, toll: 0 },
  'ambala-chandigarh': { distance: 45, toll: 60 },
  'chandigarh-ambala': { distance: 45, toll: 60 },
  'ambala-delhi': { distance: 200, toll: 280 },
  'delhi-ambala': { distance: 200, toll: 280 },
  'kurukshetra-delhi': { distance: 160, toll: 220 },
  'delhi-kurukshetra': { distance: 160, toll: 220 },
  'karnal-delhi': { distance: 130, toll: 180 },
  'delhi-karnal': { distance: 130, toll: 180 },
  'panipat-delhi': { distance: 90, toll: 120 },
  'delhi-panipat': { distance: 90, toll: 120 },
  'sonipat-delhi': { distance: 50, toll: 70 },
  'delhi-sonipat': { distance: 50, toll: 70 },
  'gurgaon-delhi': { distance: 30, toll: 40 },
  'delhi-gurgaon': { distance: 30, toll: 40 },
  'faridabad-delhi': { distance: 35, toll: 50 },
  'delhi-faridabad': { distance: 35, toll: 50 },
  'noida-delhi': { distance: 25, toll: 30 },
  'delhi-noida': { distance: 25, toll: 30 },
  'greater-noida-delhi': { distance: 45, toll: 60 },
  'delhi-greater-noida': { distance: 45, toll: 60 },
  'ghaziabad-delhi': { distance: 20, toll: 25 },
  'delhi-ghaziabad': { distance: 20, toll: 25 },
  'meerut-delhi': { distance: 70, toll: 95 },
  'delhi-meerut': { distance: 70, toll: 95 }
};

// Default distance calculation for unknown routes (approximate)
const estimateDistance = (from, to) => {
  // Simple estimation: 200km default with 280 INR toll
  return { distance: 200, toll: 280 };
};

// Get distance and toll for a route
const getRouteData = (from, to) => {
  const fromNormalized = from?.toLowerCase()?.replace(/\s+/g, '-');
  const toNormalized = to?.toLowerCase()?.replace(/\s+/g, '-');
  const routeKey = `${fromNormalized}-${toNormalized}`;

  return cityDistanceData?.[routeKey] || estimateDistance(from, to);
};

// Check if route has special pricing
const hasSpecialPricing = (from, to) => {
  const fromNormalized = from?.toLowerCase()?.replace(/\s+/g, '-');
  const toNormalized = to?.toLowerCase()?.replace(/\s+/g, '-');
  const routeKey = `${fromNormalized}-${toNormalized}`;
  return specialRoutePricing?.[routeKey] || null;
};

// Vehicle configurations with images
const vehicles = [
{
  key: 'marutiDzire',
  name: 'Maruti Dzire',
  seats: 4,
  luggage: 3,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
  alt: 'White Maruti Dzire sedan car with sleek design'
},
{
  key: 'brezza',
  name: 'Brezza',
  seats: 4,
  luggage: 4,
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_137ba9624-1768380469685.png',
  alt: 'Maruti Brezza compact SUV in modern design'
},
{
  key: 'marutiErtiga',
  name: 'Maruti Ertiga',
  seats: 6,
  luggage: 4,
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png',
  alt: 'Maruti Ertiga MPV with spacious seating capacity'
},
{
  key: 'kiaCarens',
  name: 'Kia Carens',
  seats: 6,
  luggage: 5,
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10c28221a-1768075340455.png',
  alt: 'Kia Carens premium MPV with modern features'
},
{
  key: 'innovaCrysta',
  name: 'Innova Crysta',
  seats: 6,
  luggage: 6,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
  alt: 'Toyota Innova Crysta luxury MPV in silver color'
},
{
  key: 'innovaCrysta7Plus1',
  name: 'Innova Crysta 7+1',
  seats: 7,
  luggage: 6,
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png',
  alt: 'Toyota Innova Crysta 7+1 seater configuration'
},
{
  key: 'innovaHycross',
  name: 'Innova Hycross',
  seats: 6,
  luggage: 5,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
  alt: 'Toyota Innova Hycross hybrid MPV'
}];


/**
 * Generate route data with calculated prices for all vehicles
 * @param {string} from - Starting city
 * @param {string} to - Destination city
 * @returns {object} - Route data with vehicle options and prices
 */
export const generateRouteData = (from, to) => {
  const { distance, toll } = getRouteData(from, to);
  const specialPricing = hasSpecialPricing(from, to);

  const vehiclesWithPrices = vehicles?.map((vehicle) => ({
    ...vehicle,
    price: specialPricing?.[vehicle?.key] || calculateOneWayFare(distance, vehicleRatesPerKm?.[vehicle?.key], toll)
  }));

  return {
    from,
    to,
    distance,
    toll,
    vehicles: vehiclesWithPrices
  };
};

export default {
  generateRouteData,
  vehicleRatesPerKm,
  cityDistanceData
};